import { createAsyncThunk } from "@reduxjs/toolkit";

import { createMenu as createMenuApi } from "../../../helpers/backend_helper";

export interface CreateMenuRequest {
    name: string;
    price: number;
    description?: string;
    image?: string;
    categories: string[];
    optionIds?: (string | number)[];
    options?: any[];
    menu_option_values?: Array<{
        option_value_id: string | number;
        price_modifier: number;
        is_default: boolean;
    }>;
}

export const createMenu = createAsyncThunk(
    "Web/menu/createMenu",
    async (data: CreateMenuRequest, { rejectWithValue }) => {
        try {
            const response = await createMenuApi(data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
